import SET_BASE_URL from './types';
export default {
  [SET_BASE_URL](state, payload) {
    var currentState = state;
    currentState.baseURL = payload;
  }

};